// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1EEG6","description":"PatientConsentPreview_description__2nb0y"};